import { render, staticRenderFns } from "./PhoneWizard.vue?vue&type=template&id=15692a3c&scoped=true"
import script from "./PhoneWizard.vue?vue&type=script&lang=js"
export * from "./PhoneWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15692a3c",
  null
  
)

export default component.exports